import { Component, DestroyRef, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

export const destroy = () => {
  const subject = new Subject();
  inject(DestroyRef).onDestroy(() => {
    subject.next(true);
    subject.complete();
  });

  return () => takeUntil(subject.asObservable());
};
